import { render, staticRenderFns } from "./CreditAssignmentProductEvaluateRequestPage.vue?vue&type=template&id=de50eec4&"
import script from "./CreditAssignmentProductEvaluateRequestPage.vue?vue&type=script&lang=js&"
export * from "./CreditAssignmentProductEvaluateRequestPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports